export type NavigationType = {
  href: string;
  icon: string;
  text: string;
};

export const NAVIGATION = [
  {
    href: '//instagram.com/curse_words',
    icon: 'fa fa-instagram',
    text: 'Instagram'
  },
  {
    href: '//twitter.com/CurseWordsBand',
    icon: 'fa fa-trash',
    text: 'Twitter'
  },
  {
    href: '//www.facebook.com/DontSayCurseWords/',
    icon: 'fa fa-thumbs-down',
    text: 'Facebook'
  },
  {
    href: '//dontsaycursewords.bandcamp.com/',
    icon: 'fa fa-bandcamp',
    text: 'Bandcamp'
  },
  {
    href: '//open.spotify.com/artist/5Yd3VFwLLJaSAPQRKwYXSN',
    icon: 'fa fa-spotify',
    text: 'Spotify'
  },
  {
    href: '//www.youtube.com/channel/UCAi2C7uk5a-gNXyEfqXQMRg',
    icon: 'fa fa-youtube',
    text: 'YouTube'
  },
  {
    // eslint-disable-next-line
    href: 'mailto:dontsaycursewords@gmail.com',
    icon: 'fa fa-envelope',
    text: 'Email'
  }
];
